import { h } from 'preact'
import Tabs from '../Tabs'
import LeaderboardUserList from './LeaderboardUserList'
import Phrase from '../../libs/translationsUtils/phrase'

export const allTimeRanges: Array<TimeRanges> = ['thisWeek', 'allTime']

export type TimeRanges = 'thisWeek' | 'allTime'

interface CustomDisplayOptions {
    maxResults: number,
    timeRange: Array<TimeRanges>,
    excludeRoles: Array<string>,
    emptyMessage: string,
    isPreviewEmptyMessage: boolean
}

const PointsLeaderboard = (props: CustomDisplayOptions) => {
  let tabs = props.timeRange || allTimeRanges
  const tabTitles = tabs.map(tab => {
    return <Phrase p={`leaderboard.points.${tab}`} />
  })
  return (
    <div className='leaderboard-container'>
      <Tabs titles={tabTitles}>
        {tabs.map(tab => <LeaderboardUserList
          key={tab}
          tabTitle={tab}
          maxResults={props.maxResults}
          excludeRoles={props.excludeRoles}
          emptyMessage={props.emptyMessage}
          isPreviewEmptyMessage={props.isPreviewEmptyMessage}
        />)}
      </Tabs>
    </div>
  )
}

export default PointsLeaderboard
